export default {
      id: "cargo-usage",
      viewBox: "0 0 29 16",
      url: __webpack_public_path__ + "img/icons.svg#cargo",
      toString: function () {
        return this.url;
      }
    }